/** Juridiske kontaktoplysninger — kan overrides via Vite env i produktion. */
export const LEGAL_SITE_URL =
  import.meta.env.VITE_LEGAL_SITE_URL ?? 'https://touchtype.babehill.com';

export const LEGAL_DATA_CONTROLLER =
  import.meta.env.VITE_LEGAL_DATA_CONTROLLER ?? 'TouchType (babehill.com)';

export const LEGAL_CONTACT_EMAIL =
  import.meta.env.VITE_LEGAL_CONTACT_EMAIL ?? 'touchtype@babehill.com';

export const LEGAL_LAST_UPDATED = '22. juni 2026';
